import type { ActionCandidate } from "../../../types/candidate";
import { useRootStore } from "../../../stores/hooks";

/**
 * Because the action description gets filled out empty at first, we use this help to find a value from the current description
 * Once it has been dynamically loaded that version will be used
 */
export const useFindActionAuthenticationIds = (): ((
  action: ActionCandidate,
) => string[]) => {
  const store = useRootStore();

  return (action) => {
    if (action.description.actionId !== "") {
      return action.description.authenticationId;
    }

    const integration = store.integrations.list.find(
      (item) => item.integrationId === action.actionReference?.integrationId,
    );
    const actionDescription = integration?.actions.find(
      (item) => item.actionId === action.actionReference?.actionId,
    );
    return actionDescription?.authenticationId ?? [];
  };
};
